import React, { useState } from "react";
import { Link as RouterLink } from "react-router-dom";
import {
  Box,
  Button,
  Container,
  Link,
  TextField,
  Typography,
  Paper,
} from "@mui/material";
// import { useAuth } from '../contexts/AuthContext';
import { forgotPassword } from "../api/Authentication/api";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await forgotPassword(email);
      setMessage("Password reset link has been sent to your email");
      setError("");
    } catch (err) {
      setError("Failed to send reset link");
      setMessage("");
    }
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: "#A8CE97", // Light green background
      }}
    >
      <Container maxWidth="xs">
        <Paper elevation={3} sx={{ p: 4, borderRadius: 3 }}>
          <Box display="flex" justifyContent="left" mb={3}>
            <img src="/logo.svg" alt="Logo" style={{ height: 40 }} />
          </Box>
          <Box component="form" onSubmit={handleSubmit}>
            <Typography
              variant="h5"
              align="left"
              fontWeight="bold"
              gutterBottom
              sx={{ color: "#124F3E" }} // Dark green text color
            >
              Forgot Password
            </Typography>
            <Typography variant="body1" align="left" sx={{ mb: 3 }}>
              Enter your account's email address and we'll send you a link to
              reset your password
            </Typography>
            {error && (
              <Typography color="error" align="center" sx={{ mb: 2 }}>
                {error}
              </Typography>
            )}
            {message && (
              <Typography color="success.main" align="center" sx={{ mb: 2 }}>
                {message}
              </Typography>
            )}
            <TextField
              fullWidth
              label="Email"
              type="email"
              margin="normal"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <Button
              fullWidth
              type="submit"
              variant="contained"
              sx={{
                mt: 3,
                mb: 2,
                bgcolor: "#124F3E",
                ":hover": { bgcolor: "#0E3D30" },
              }}
            >
              Submit
            </Button>
            <Typography align="center">
              <Link
                component={RouterLink}
                to="/login"
                sx={{ color: "#124F3E" }}
              >
                Back to Login
              </Link>
            </Typography>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
};

export default ForgotPassword;
